import { EventEmitterEvent, EventEmitterInit } from './types';

/**
 * Create an instance of {@link EventEmitterEvent}.
 *
 * @param targetObject The object emitting the event.
 * @param type This is a string representing the name of the event.
 * @param customEventInit Optionally modify the Event settings.
 */
// There are issues extending `Event` or `CustomEvent`, so we'll use a factory
// to build the `EventEmitterEvent` event.
function createEventEmitterEvent<T = unknown>(
    targetObject: unknown,
    type: string,
    customEventInit?: CustomEventInit
): EventEmitterEvent<T> {
    const theEvent = new CustomEvent(type, customEventInit) as EventEmitterEvent<T>;
    theEvent.targetObject = targetObject;

    return theEvent;
}

export function emitEvent(
    targetObject: unknown,
    eventEmitterElement: EventTarget,
    type: string,
    detail: unknown = null,
    customEventInit?: EventEmitterInit
): boolean {
    const customEventInitSettings: CustomEventInit = { bubbles: true, cancelable: false };

    if (customEventInit) {
        Object.assign(customEventInitSettings, customEventInit);
    }

    // Make sure the `detail` parameter overwrites
    // `customEventInit.detail` if it was mistakenly provided.
    customEventInitSettings.detail = detail;

    const theEvent = createEventEmitterEvent<typeof detail>(
        targetObject,
        type,
        customEventInitSettings
    );

    // Trigger it!
    return eventEmitterElement.dispatchEvent(theEvent);
}
